<template>
  <button
    class="stepper-control__btn--down"
    :disabled="disabled || null"
    @click="onClick"
  >
    <ChevronDown class="stepper-control__btn-icon--down" />
  </button>
</template>
<script>
import ChevronDown from '../../atoms/svg_icons/ChevronDown.vue'

export default {
  components: {
    ChevronDown
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    onClick() {
      this.$emit('click-stepper-control-btn-down')
    }
  }
}
</script>
<style lang="scss" scoped>
.stepper-control {
  &__btn--down {
    width: 36px;
    height: 36px;
    background-color: $black;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:disabled {
      cursor: default;
      background-color: $gray-2;
    }
  }

  &__btn-icon--down {
    fill: $white;
  }
}
</style>
